import * as ActionTypes from '../constants/ActionTypes';
import { fromJS } from 'immutable';
import { find } from 'lodash';

import { push } from 'react-router-redux';

import { clearEntities } from './entities';
import { resetCustomer } from './customer';
import { setMessage } from './systemMessage';
import { resetPlan } from './plan';
import { confirmInvite, resetMerchant } from './merchant';
import { api } from '../store';
import { searchActiveMerchants, setSearchTerm } from './search';
import { getCustomerDetails } from './customer';
import SupplyInvite from '../records/supply-invite';

import { Events } from 'ui-utilities';

const RESOURCE = 'users';

function destination(state, redirect) {
  // no existing merchant selected, either chose new listing or searched for something that doesn't exist
  if (!state.search.get('selectedMerchantId') && (state.auth.get('merchant').get('new') || state.search.get('currentSearchTerm') !== '')) {
    redirect = '/plan';
  // clicked on self in search results
  } else if (state.search.get('selectedMerchantId') && state.entities.get('merchant').find(m => m.vendor_id === state.search.get('selectedMerchantId')).get('vendor').get('user_id') === state.auth.get('user').get('user_id')) {
    redirect = '/dashboard';
  // clicked on an existing merchant/vendor and it's in merchant entities
  } else if (state.entities.get('merchant').size > 0 && state.search.get('selectedMerchantId')) {
    redirect = '/verify';
  }

  return redirect;
}

// ----------------------
// Action Creators
// ----------------------

export const autoLogin = (attributes, auto) => {
  return (dispatch, getState) => {
    if (!getState().auth.get('user').get('isLoggedIn')) {
      dispatch({
        type: ActionTypes.LOG_IN,
        payload: attributes,
        auto: auto
      });

      return dispatch(getCustomerDetails())
        .then(res => Events
          .provide('kissmetrics', true)
          .log('identify', getState().customer.get('account').get('email'))
          .service
          .log('record', 'Merchant Sign-in'))
        .catch(err => console.log(err));
    }
  }
}

export const clearAuth = () => ({
  type: ActionTypes.CLEAR_AUTH
});

export const forgot = inputs => {
  return dispatch => {
    return api().post({
      resource: 'auth/token'
    }, api().payload('magic_link', {
      username: find(inputs, i => i.label === 'email').validations.val.toLowerCase()
    }))
    .then(res => dispatch(clearAuth()));
  }
}

export const refresh = token => {
  return dispatch => {
    return api().post({
      resource: 'auth/token'
    }, api().payload('refresh_token', {
      refresh_token: token
    }))
    .then(res => dispatch(autoLogin(res.data.attributes)))
    .then(res => dispatch(push('/dashboard')))
    .catch(err => dispatch(setMessage('error', 'Unable to authenticate with refresh token')));
  }
}

export const handleInvite = () => {
  return (dispatch, getState) => {
    let promise;
    const inviteCode = getState()
      .merchant
      .get('invite_code');

    inviteCode ? promise = new SupplyInvite().$get(null, inviteCode) : promise = Promise.resolve({ data: [] })

    promise.then(invite => {
      if (invite.data.length > 0) {
        const vendorId = invite.data[0].attributes.invited_vendor_id;

        // invited as a new business, setup a new plan
        if (!vendorId) {
          return dispatch(push('/plan'))
        }

        return dispatch(searchActiveMerchants(fromJS([vendorId])))
          .then(res => getState().entities.get('merchant').find(m => m.vendor_id === vendorId).vendor.get('claimed'))
          .then(claimed => {
            if (claimed) {
              dispatch(push('/dashboard#farmers'));
              return dispatch(confirmInvite(invite.data[0].id));
            } else {
              return dispatch(push('/verify'));
            }
          });
      }
    });
  }
}

export function logIn(inputs, redirect) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.AUTH_LOADING,
      payload: true
    });

    return api().post({
      resource: 'auth/token'
    }, api().payload('password', {
      username: find(inputs, i => i.label === 'email').validations.val.toLowerCase(),
      password: find(inputs, i => i.label === 'password').validations.val
    }))
    .then(res => dispatch(autoLogin(res.data.attributes)))
    .then(res => dispatch(handleInvite()))
    .then(res => dispatch(push(destination(getState(), redirect) || '/dashboard')))
    //.then(res => dispatch(setSearchTerm('', null)))
    .then(res => dispatch({
      type: ActionTypes.AUTH_LOADING,
      payload: false
    }))
    .then(() => getState().auth.get('errors'))
    .catch(err => {
      dispatch({
        type: ActionTypes.AUTH_LOADING,
        payload: false
      });

      return dispatch({
        type: ActionTypes.LOG_IN,
        error: err
      })
    });
  };
}

export const resetLogin = () => ({
  type: ActionTypes.RESET_LOGIN
});

export function logOut() {
  return dispatch => {
    dispatch(clearAuth());
    dispatch(clearEntities());
    dispatch(resetPlan());
    dispatch(resetCustomer());
    dispatch(resetMerchant());
    dispatch(setSearchTerm('', null));

    localStorage.clear();
    return dispatch(push('/'));
  }
}

export function signUp(inputs) {
  return (dispatch, getState) => {
    return api().post({
      resource: RESOURCE
    }, api().payload(RESOURCE, {
      email: find(inputs, i => i.label === 'email').validations.val.toLowerCase(),
      password: find(inputs, i => i.label === 'password').validations.val,
      first_name: find(inputs, i => i.label === 'name').validations.val,
      postal_code: find(inputs, i => i.label === 'zip').validations.val
    }))
    .then(res => Events
      .provide('kissmetrics', true)
      .log(
        'record',
        'Merchant Sign-up Complete Form', {
          'User Email': find(inputs, i => i.label === 'email').validations.val.toLowerCase(),
          'User Location': getState().customer.get('location').get('place_name')
        }
      ))
    .then(res => dispatch(logIn(inputs, '/search')))
    .then(() => getState().auth.get('errors'))
    .catch(err => dispatch({
      type: ActionTypes.LOG_IN,
      error: [{
        detail: 'There was a problem creating your account: ' + err
      }]
    }));
  }
}

export const toggleAuthenticationModal = (event, creating) => {
  return dispatch => {
    dispatch({
      type: ActionTypes.TOGGLE_AUTHENTICATION_MODAL,
      creating: creating
    });
  }
};

export function validateEmail(email, setState = true) {
  return dispatch => {
    if (email !== '') {
      return api().get({
        resource: RESOURCE + '/?filter[email]=' + encodeURIComponent(email.toLowerCase())
      })
      .then(res => {
        if (res.data.length < 1) return res;

        res.data[0].attributes.auto_generated && dispatch({
          type: ActionTypes.AUTO_PASSWORD
        });
        return res;
      })
      .then(res => {
        if (setState) {
          dispatch({
            type: ActionTypes.VALIDATE_EMAIL,
            payload: res.data
          });
        }
        return res;
      });
    } else {
      return Promise.reject('No email');
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js